import React from "react";

import { Row, Container } from "react-bootstrap";

import { Content } from "./styles";

import { useOpen } from "../../hooks/Open";

import { useNavigate } from "react-router";
import { IoSearchOutline } from "react-icons/io5";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

export default function NotFound() {
  const screenName = useScreenTracking();
  const { OpenSearch } = useOpen();
  const navigate = useNavigate();

  const handleRefazerBusca = () => {
    trackClick({
      title: "refazer-busca",
      contentType: "busca",
      screenName,
      tagId: tagIdFromLegacySuffix("12"),
    });
    OpenSearch();
  };

  return (
    <>
      <Container className="mt-5">
        <Container>
          <Content>
            <Row className="text-center justify-content-center">
              <Typography sx={{ fontSize: 22 }}>
                Produto não encontrado
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ padding: "2em", color: "#696969", fontSize: 14 }}
              >
                Não encontramos nenhum <br /> resultado na busca solicitada.{" "}
                <br /> Tente novamente.
              </Typography>
              <Button
                className="btn btn-default-wl"
                onClick={handleRefazerBusca}
                sx={{ marginTop: "2em", borderRadius: "var(--button-border-radius)", width: 187, height: 30
                 }}
              >
                <IoSearchOutline size="1.2em" />
                <Typography
                  variant="button"
                  sx={{
                    paddingLeft: "1em",
                    fontFamily: "Source Sans Pro",
                    fontWeight: 700,
                    fontSize: 10
                  }}
                >
                  Refazer busca
                </Typography>
              </Button>
            </Row>
          </Content>
        </Container>
      </Container>
    </>
  );
}
